/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
import { connect } from "react-redux";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

import { useTranslation } from "react-i18next";

// Images
// import bgImage from "assets/images/ondas-onna.jpg";
import { initializeApp } from "firebase/app";
import { getAuth, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { newAlertMessage } from "store/actions/globalAlertActions";

import Logo from "assets/images/logoOnna.svg";
import PropTypes from "prop-types";

import appConfig from "../../../../utils/appConfig";

const firebaseApp = initializeApp(appConfig);

// Initialize Firebase
const auth = getAuth(firebaseApp);

function Cover({ actNewAlertMessage }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const { t } = useTranslation();
  const signIn = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setMessage("");
    } catch (error) {
      switch (error.code) {
        case "auth/wrong-password":
        case "auth/invalid-credential":
        case "auth/invalid-login-credentials":
        case "auth/invalid-email":
          setMessage(t("wrongPasswordForExistingEmail"));
          break;

        case "auth/user-not-found":
          setMessage(t("userNotFound"));
          break;
        default:
          break;
      }
    }
  };

  return (
    <CoverLayout>
      <Card>
        <MDBox
          pt={4}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <img alt="" src={Logo} width="120" />
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="email"
                autoComplete="username"
                label="Email"
                variant="standard"
                fullWidth
                placeholder="john@example.com"
                InputLabelProps={{ shrink: true }}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                autoComplete="current-password"
                label={t("password")}
                variant="standard"
                fullWidth
                placeholder="************"
                InputLabelProps={{ shrink: true }}
                error={!!message}
                helperText={message}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={() => {
                  signIn();
                }}
              >
                {t("signIn")}
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} display="flex" flexDirection="column" textAlign="center">
              <MDTypography variant="button" color="text">
                {`${t("forgotPassword")} `}
                <MDTypography
                  component={Link}
                  variant="button"
                  color="info"
                  to="/authentication/sign-up/cover"
                  fontWeight="medium"
                  textGradient
                  onClick={(event) => {
                    event.preventDefault();
                    sendPasswordResetEmail(auth, email)
                      .then(() => {
                        actNewAlertMessage({
                          type: "success",
                          title: "Email",
                          content: t("emailResetSent"),
                        });
                      })
                      .catch(() => {
                        setMessage(t("invalidEmail"));
                      });
                  }}
                >
                  {t("resetPassword")}
                </MDTypography>
              </MDTypography>
              <MDTypography variant="button" color="text">
                {`${t("dontHaveAccount")} `}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up/cover"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  {t("signUp")}
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

Cover.defaultProps = {};

Cover.propTypes = {
  actNewAlertMessage: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  actNewAlertMessage: (message) => dispatch(newAlertMessage(message)),
});

export default connect(null, mapDispatchToProps)(Cover);
